import { Component, Inject, OnInit, AfterViewInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatDatepicker } from '@angular/material/datepicker';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { TooltipPosition } from '@angular/material/tooltip';
import moment, { Moment } from 'moment';
import { ApplicationDataService } from 'src/app/services/application-data.service';
import { ExcelService } from 'src/app/services/excel.service';
import { LookupDataServiceService } from 'src/app/services/lookup-data-service.service';
import { NotificationService } from 'src/app/services/notification-service';
import { ReportService } from 'src/app/services/report.service';
import { UploaddataService } from 'src/app/services/uploaddata.service';
import { MY_DATE_FORMATS } from 'src/app/shared/validators/mat-date-formatter';
import Swal from 'sweetalert2';

@Component({
    selector: 'app-report-modal-dialog',
    templateUrl: './report-modal-dialog.component.html',
    styleUrls: ['./report-modal-dialog.component.scss'],
    providers: [
        {
            provide: DateAdapter,
            useClass: MomentDateAdapter,
            deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
        },

        { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS },
    ],
})
export class ReportModalDialogComponent implements OnInit, AfterViewInit {
    debitOrderBatchForm: FormGroup
    SendOverEmailForm: FormGroup
    minDate: Date;
    maxDate: Date;
    date = new FormControl(moment());
    selectedDate: any
    emailAddressList: any[];
    DebitDateTypeList: any[];
    filteredListEmailAddressList: any[];
    filteredListDebitDateTypeList: any[];
    manualDebit: boolean = false;
    manualDebitCpy: boolean = false;
    @ViewChild('startDate') startDatePicker: MatDatepicker<Date>;
    sendFrom: string
    displayType: string;
    MatDialogTitle = 'Confirmation';
    customerVerification: boolean = false;
    productVerification: boolean = false;
    batches: number;
    counts: number;
    isShowNextPage: boolean = false;
    files: any;
    selectedFile: File | null = null;


    UploadExcelFileForm: any;
    title: string = 'Upload Debit Order';
    fileName: string;
    FileExtention: string;
    dataSubmitToPaySoft: any[] = [];
    dataSource = new MatTableDataSource<any>();
    displayedColumns: string[] = [
        'CustomerCode',
        'CustomerName',
        'Reference',
        'Amount',

    ];

    displayedColumnsSuspension: string[] = [
        'CustomerNumber',
        'Balance',
    ];
    positionOptions: TooltipPosition[] = ['below', 'above', 'left', 'right'];
    position = new FormControl(this.positionOptions[0]);
    @ViewChild(MatPaginator, { static: true }) paginatorRef: MatPaginator;
    base64String: string;
    fileData: any[] = [];
    templatedata: any[] = [];
    isShowUploadExcelFile: boolean = false;
    isFileSelected: boolean = true;
    suspensionDataSubmit: any[];
    manageSuspensionId: any;

    constructor(
        @Inject(MAT_DIALOG_DATA) public popupdata: any,
        public dialogRef: MatDialogRef<ReportModalDialogComponent>,
        private reportService: ReportService,
        private lookupDataService: LookupDataServiceService,
        private applicationDataService: ApplicationDataService,
        private fb: FormBuilder,
        private toastr: NotificationService,
        private uploadDataService: UploaddataService,
        private ExcelService: ExcelService

    ) { }

    ngOnInit(): void {
        if (this.popupdata) {
            if (this.popupdata.displayPanel) {
                debugger
                this.displayType = this.popupdata.displayPanel;
                var maxDates = new Date();
                maxDates.setMonth(maxDates.getMonth() + 1);
                this.maxDate = new Date(maxDates.getFullYear(), maxDates.getMonth(), maxDates.getDate())

                var minDates = new Date();
                minDates.setMonth(minDates.getMonth() - 1);
                this.minDate = new Date(minDates.getFullYear(), minDates.getMonth(), 1)
                if (this.displayType === 'uploadExcelFile') {
                    this.isShowUploadExcelFile = false;
                }
                if (this.displayType === 'uploadSuspensionExcelFile') {
                    this.manageSuspensionId = this.popupdata.manageSuspensionId;
                }
            }
        }
        this.initializeValidators();
    }

    ngAfterViewInit(): void {
        if (this.dataSource) {
            this.dataSource.paginator = this.paginatorRef;
        }
    }

    OnClickCheckBox() {
        this.manualDebitCpy = !this.manualDebitCpy;
    }

    OpenDatePicker() {
        this.startDatePicker.open();
    }

    saveDebitOrderBatch() {
        if (this.debitOrderBatchForm.valid) {
            let formValues = this.debitOrderBatchForm.getRawValue();
            const dateString = formValues.startDate;
            const date = new Date(dateString);
            const year = date.getFullYear();
            const monthName = new Intl.DateTimeFormat('en-US', { month: 'long' }).format(date);
            const formattedDate = `${year}/${monthName}`;

            let payload = {
                email: formValues.email,
                debitDate: formValues.TrackFrogfoot,
                startDate: formattedDate,
                reportType: 6,
                manualDebit: this.manualDebitCpy ? true : false
            };
            this.applicationDataService.saveReportSearch(payload).subscribe((UserApplicationsAndRequestRes) => {
                if (UserApplicationsAndRequestRes) {
                    this.dialogRef.close();
                    this.displayReportGeneratingModal();
                } else {
                    Swal.fire(
                        'Oops!!',
                        `Please try again later!`,
                        'warning'
                    );
                }
            });
        }
        else {
            this.debitOrderBatchForm.markAllAsTouched();
            this.toastr.showError("Please fill in all mandatory fields")
        }
    }

    initializeValidators() {

        if (this.displayType === 'GenDebitOrderBatch') {
            this.debitOrderBatchForm = this.fb.group({
                startDate: ['', Validators.required],
                TrackFrogfoot: ['', Validators.required],
                email: ['', Validators.required],
                manualDebit: ['']
            });
            this.DateOfDebit();
            this.getEmailList();
        } else if (this.displayType === 'SendOverEmail') {
            this.SendOverEmailForm = this.fb.group({
                email: ['', Validators.required]
            });
            this.getEmailList();
        } else if (['uploadExcelFile', 'suspension', 'uploadSuspensionExcelFile'].includes(this.displayType)) {
            this.UploadExcelFileForm = this.fb.group({
                AttachmentFileName: ['', Validators.required],
            });
            if (this.displayType === 'uploadSuspensionExcelFile') {
                this.ViewSuspensionData(this.popupdata.tableData);
            }
        } else if (this.displayType === 'uploadExcelFileTable') {
            this.ViewDoc(this.popupdata.tableData);
        }
    }

    DateOfDebit() {
        this.lookupDataService.getReportDebitDateType(true).subscribe((res: any) => {
            if (res) {
                this.DebitDateTypeList = res;
                this.filteredListDebitDateTypeList = this.DebitDateTypeList.slice();
            }
        });
    }

    getEmailList() {
        this.reportService.getEmailForReportDropDown().subscribe((res: any) => {
            if (res) {
                this.emailAddressList = res;
                this.filteredListEmailAddressList = this.emailAddressList.slice();
            }
        });
    }

    saveGenerateDebitOrderExcelSheet() {
        if (this.SendOverEmailForm.valid) {
            let formValues = this.SendOverEmailForm.getRawValue();
            let payload = {
                email: formValues.email,
                reportType: this.popupdata.reportType,
                startDate: this.popupdata.startDate,
                endDate: null
            };
            this.applicationDataService.saveReportSearch(payload).subscribe((UserApplicationsAndRequestRes) => {
                if (UserApplicationsAndRequestRes) {
                    this.dialogRef.close();
                    this.displayReportGeneratingModal();
                } else {
                    Swal.fire(
                        'Oops!!',
                        `Please try again later!`,
                        'warning'
                    );
                }
            });
        }
        else {
            this.SendOverEmailForm.markAllAsTouched();
            this.toastr.showError("Please fill in all mandatory fields")
        }
    }

    displayReportGeneratingModal() {
        Swal.fire({
            // title: "Report Generating...",
            text: "The report is being generated and will be delivered shortly to the specified email address",
            // imageUrl: "../../../../../assets/Home-Connect/icons/reportGenerating.gif",
            // imageAlt: "report Generating GIF"
            icon: 'success'
        });
    }

    setMonthAndYear(normalizedMonthAndYear: Moment, datepicker: MatDatepicker<Moment>) {
        const ctrlValue = this.date.value ?? moment();
        ctrlValue.month(normalizedMonthAndYear.month());
        ctrlValue.year(normalizedMonthAndYear.year());
        this.selectedDate = ctrlValue;
        this.debitOrderBatchForm.controls['startDate'].setValue(ctrlValue);
        datepicker.close();
    }

    Close() {
        this.dialogRef.close();
    }
    downloadReport() {
        var postData = {};
        this.reportService.getApprovedRecurringReport(postData).subscribe(res => {
            if (res) {
                const linkSource = 'data:application/pdf;base64, ' + res;
                const downloadLink = document.createElement('a');
                const fileName = `HC Recurring Approved Invoice Report.xls`;
                downloadLink.href = linkSource;
                downloadLink.download = fileName;
                downloadLink.click();
                this.toastr.showSuccess(`Invoice report downloaded successfully`);
            }
        });
    }

    Proceed() {
        this.applicationDataService.approveRecurringInvoiceValidation()
            .subscribe(result => {
                if (result) {
                    this.isShowNextPage = true;
                    this.MatDialogTitle = 'Billing Verification';
                    this.customerVerification = result.customerVerification;
                    this.productVerification = result.productVerification;
                    this.batches = result.batches;
                    this.counts = result.counts;
                }
            });
    }

    goBack() {
        this.dialogRef.close();
    }



    selectFile() {
        const inputElement = document.createElement('input');
        inputElement.type = 'file';
        inputElement.style.display = 'none';
        document.body.appendChild(inputElement);
        inputElement.click();
        inputElement.addEventListener('change', (event) => {
            const files: FileList = (event.target as HTMLInputElement).files;
            if (!files || files.length == 0) {
                Swal.fire('Warning', 'Please upload file', 'warning');
                return;
            }

            if (!files || files.length > 2) {
                Swal.fire('Warning', 'Please one file at a time', 'warning');
                return;
            }

            this.fileName = files.item(0).name;
            var file = files.item(0);
            var fileExtension = this.fileName.slice(
                this.fileName.lastIndexOf('.') + 1
            );
            var type =
                '|' + file.type.slice(file.type.lastIndexOf('/') + 1) + '|';
            var result =
                '|csv|xlsx|xls|'.indexOf(type) !== -1 ||
                '|csv|xlsx|xls|'.indexOf(fileExtension) !== -1;

            if (!result) {
                Swal.fire(
                    'Warning',
                    `Please upload a Correct File Format (csv, xlsx, xls)`,
                    'warning'
                );
                this.fileName = ' ';

                this.isFileSelected = true;
                return;
            }

            this.FileExtention = fileExtension;
            this.isFileSelected = false;
            this.files = file


            document.body.removeChild(inputElement);
            this.UploadExcelFileForm.controls['AttachmentFileName'].setValue(this.fileName);
            // this.ExcelService.readSheetOneData(this.files, 'noload').then((res) => {
            //     if (res) {
            //         this.fileData = res;
            //     }
            // });
        });
    }

    ViewDoc(tableData) {
        this.ExcelService.readSheetOneData(tableData, 'noload').then((res) => {
            if (res) {
                this.fileData = res;
                this.files = tableData;
                this.processDataAndDisplayInTable(this.fileData);
                this.title = 'View Debit Order';
            }
        });

    }

    ViewSuspensionData(tableData) {
        this.ExcelService.readSheetOneData(tableData, 'noload').then((res) => {
            if (res) {
                const validation = this.validateSuspensionExcel(res);
                if (!validation.isValid) {
                    Swal.fire("Invalid File", validation.errorMessage, "error");
                    return; // stop here, don't set this.files or proceed
                }

                this.fileData = res;
                this.files = tableData;
                this.processSuspensionDataAndDisplayInTable(this.fileData);
                this.title = 'View Suspension Data';
            }
        });

    }


    validateSuspensionExcel(data: any[]): { isValid: boolean, errorMessage: string } {
        if (!data || data.length < 2) {
            return { isValid: false, errorMessage: "The uploaded file has no data." };
        }

        const headerRow = data[0];

        // Column count check
        if (!headerRow || headerRow.length !== 2) {
            return { isValid: false, errorMessage: "The file must contain exactly 2 columns: CustomerCode and Amount." };
        }

        // Header name check
        const expectedHeaders = ['customer number', 'balance'];
        const actualHeaders = headerRow.map(h => (h ?? '').toString().trim().toLowerCase());

        if (actualHeaders[0] !== expectedHeaders[0] || actualHeaders[1] !== expectedHeaders[1]) {
            return { isValid: false, errorMessage: "The file headers must be 'Customer Number' and 'Balance'." };
        }

        // Row-level validation
        for (let i = 1; i < data.length; i++) {
            const row = data[i];
            if (!row || row.length === 0) continue;

            if (row.length > 2) {
                return { isValid: false, errorMessage: "The file contains extra columns. Only CustomerNumber and Balance are allowed." };
            }

            const customerCode = row[0];
            const amount = row[1];

            if (customerCode === undefined || customerCode === null || customerCode.toString().trim() === '') {
                return { isValid: false, errorMessage: "One or more rows have a missing CustomerNumber." };
            }

            if (amount === undefined || amount === null || amount.toString().trim() === '' || isNaN(Number(amount))) {
                return { isValid: false, errorMessage: "One or more rows have a missing or invalid Balance." };
            }
        }

        return { isValid: true, errorMessage: '' };
    }


    closeUpload() {
        this.dialogRef.close(this.files);
    }

    onFileSelected(event: Event) {
        const input = event.target as HTMLInputElement;
        if (input.files && input.files.length > 0) {
            console.log('File selected:', this.selectedFile.name);
        } else {
            this.selectedFile = null;
        }
    }


    sendToPaySoft() {
        if (!this.files || this.files.length === 0) {
            alert('No file selected!');
            return;
        }

        this.uploadDataService.debitFormDocumentUpload(this.dataSubmitToPaySoft).subscribe((res) => {
            if (res) {
                const file = this.files;
                const formData = new FormData();
                formData.append('file', this.files);

                this.uploadDataService.UploadExcelOnly(formData).subscribe((res: any) => {
                    if (res) {
                        console.log('Upload success:', res);
                        Swal.fire("Success!", "Report Generating...<br>The document uploaded", "success");
                        this.dialogRef.close('CloseAll');
                    }
                },
                    (err) => {
                        console.error('Upload error:', err);
                        if (err.error && typeof err.error === 'string') {
                            alert(`Upload failed: ${err.error}`);
                        } else if (err.message) {
                            alert(`Upload failed: ${err.message}`);
                        } else {
                            alert('Server or network error.');
                        }
                    }
                );
                this.dialogRef.close('CloseAll');
                Swal.fire("Success!", "Report Generating...<br>The document uploaded", "success")

            } else {
                Swal.fire(
                    'Warning',
                    `Please try again later!`,
                    'warning'
                );
            }
        });
    }

    proceedForSuspensionProcess() {
        const formData = new FormData();
        formData.append('file', this.files, this.files.name);
        this.manageSuspensionId = this.popupdata.manageSuspensionId;

        this.uploadDataService.SubmitSuspensionApprovalExcel(this.manageSuspensionId, formData)
            .subscribe(
                (res: any) => {
                    if (res) {
                        console.log('Upload success:', res);
                        Swal.fire("Success!", "Document Uploaded Successfully.Processing will commence shortly.", "success");
                        this.dialogRef.close('CloseAll');
                    }
                },
                (err) => {
                    console.error('Upload failed:', err);
                    Swal.fire("Error", "File upload failed", "error");
                }
            );
    }

    reset() {
        const txt = 'Are you sure want to delete?';
        const Yes = 'Yes';
        const No = 'No';
        Swal.fire({
            text: txt,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#7D32DE',
            cancelButtonColor: '#23C00A',
            confirmButtonText: Yes,
            cancelButtonText: No,
        }).then((result) => {
            if (result.value) {
                this.fileName = "";
                this.isFileSelected = true;
                this.selectedFile = null;
                this.UploadExcelFileForm.controls['AttachmentFileName'].setValue(this.fileName);

            }
        });
    }
    processDataAndDisplayInTable(data: any[]): void {
        this.templatedata = [];
        data.forEach((x, i = 1) => {
            this.templatedata.push({
                CustomerCode: data[i][0],
                CustomerName: data[i][1],
                Reference: data[i][2],
                Amount: data[i][3]
            })
            i++;
        })
        this.templatedata.shift();
        this.dataSubmitToPaySoft = this.templatedata;
        this.dataSource = new MatTableDataSource(this.templatedata);
        if (this.paginatorRef) {
            this.dataSource.paginator = this.paginatorRef;
        }
    }

    processSuspensionDataAndDisplayInTable(data: any[]): void {
        this.templatedata = [];
        data.forEach((x, i = 1) => {
            this.templatedata.push({
                CustomerNumber: data[i][0],
                Balance: data[i][1]
            })
            i++;
        })
        this.templatedata.shift();
        this.suspensionDataSubmit = this.templatedata;
        this.dataSource = new MatTableDataSource(this.templatedata);
        if (this.paginatorRef) {
            this.dataSource.paginator = this.paginatorRef;
        }
    }

    ProceedInvoice() {
        const postData: any = { startDate: this.popupdata.startDate }
        this.applicationDataService.approveRecurringInvoice(postData).subscribe((response) => {
            if (response == "true") {
                Swal.fire(
                    'Success!',
                    `Process was Initialized successfully!`,
                    'success'
                );
                this.dialogRef.close();
            } else {
                Swal.fire(
                    'Oops!!',
                    response,
                    'warning'
                );
            }
        });
    }



}


